import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import SignalementForm from '../components/report/SignalementForm';

export default function ReportPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <div className="page-container">
      <Header showBack backLabel="Signalement" onBack={() => navigate(-1)} />
      <SignalementForm analysis={state?.analysis} onDone={() => navigate('/')} />
    </div>
  );
}
